// extracted by mini-css-extract-plugin
export default {"row":"SearchGamesList__row___VwX95IO4","cell":"SearchGamesList__cell___odvx2ly5","adCell":"SearchGamesList__adCell___O9BVpaBS"};